import "vanilla-cookieconsent/dist/cookieconsent.css";
import CookieConsent from "vanilla-cookieconsent/dist/cookieconsent.umd.js";

const CAT_NECESSARY = "necessary";
const CAT_ANALYTICS = "analytics";
const CAT_ADVERTISEMENT = "advertisement";
const CAT_FUNCTIONALITY = "functionality";
const CAT_SECURITY = "security";

const SERVICE_AD_STORAGE = 'ad_storage'
const SERVICE_AD_USER_DATA = 'ad_user_data'
const SERVICE_AD_PERSONALIZATION = 'ad_personalization'
const SERVICE_ANALYTICS_STORAGE = 'analytics_storage'
const SERVICE_FUNCTIONALITY_STORAGE = 'functionality_storage'
const SERVICE_PERSONALIZATION_STORAGE = 'personalization_storage'
const SERVICE_SECURITY_STORAGE = 'security_storage'

// Define dataLayer and the gtag function.
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

/**
 * Update gtag consent according to the users choices made in CookieConsent UI
 */
function updateGtagConsent() {
    gtag('consent', 'update', {
        [SERVICE_ANALYTICS_STORAGE]: CookieConsent.acceptedService(SERVICE_ANALYTICS_STORAGE, CAT_ANALYTICS) ? 'granted' : 'denied',
        // [SERVICE_AD_STORAGE]: CookieConsent.acceptedService(SERVICE_AD_STORAGE, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
        // [SERVICE_AD_USER_DATA]: CookieConsent.acceptedService(SERVICE_AD_USER_DATA, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
        // [SERVICE_AD_PERSONALIZATION]: CookieConsent.acceptedService(SERVICE_AD_PERSONALIZATION, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
        // [SERVICE_FUNCTIONALITY_STORAGE]: CookieConsent.acceptedService(SERVICE_FUNCTIONALITY_STORAGE, CAT_FUNCTIONALITY) ? 'granted' : 'denied',
        // [SERVICE_PERSONALIZATION_STORAGE]: CookieConsent.acceptedService(SERVICE_PERSONALIZATION_STORAGE, CAT_FUNCTIONALITY) ? 'granted' : 'denied',
        // [SERVICE_SECURITY_STORAGE]: CookieConsent.acceptedService(SERVICE_SECURITY_STORAGE, CAT_SECURITY) ? 'granted' : 'denied',
    });
}

CookieConsent.run({
    guiOptions: {
        consentModal: {
            layout: "box",
            position: "bottom right",
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: true,
            flipButtons: false
        }
    },

    // Trigger consent update when user choices change
    onFirstConsent: () => {
        updateGtagConsent();
    },
    onConsent: () => {
        updateGtagConsent();
    },
    onChange: () => {
        updateGtagConsent();
    },

    // Configure categories and services
    categories: {
        [CAT_NECESSARY]: {
            enabled: true,  // this category is enabled by default
            readOnly: true,  // this category cannot be disabled
        },
        [CAT_ANALYTICS]: {
            autoClear: {
                cookies: [
                    {
                        name: /^_ga/,   // regex: match all cookies starting with '_ga'
                    },
                    {
                        name: '_gid',   // string: exact cookie name
                    }
                ]
            },
            // See: https://cookieconsent.orestbida.com/reference/configuration-reference.html#category-services
            services: {
                [SERVICE_ANALYTICS_STORAGE]: {
                    label: 'Enables storage (such as cookies) related to analytics e.g. visit duration.',
                }
            }
        },
        // [CAT_ADVERTISEMENT]: {
        //     services: {
        //         [SERVICE_AD_STORAGE]: {
        //             label: 'Enables storage (such as cookies) related to advertising.',
        //         },
        //         [SERVICE_AD_USER_DATA]: {
        //             label: 'Sets consent for sending user data related to advertising to Google.',
        //         },
        //         [SERVICE_AD_PERSONALIZATION]: {
        //             label: 'Sets consent for personalized advertising.',
        //         },
        //     }
        // },
        // [CAT_FUNCTIONALITY]: {
        //     services: {
        //         [SERVICE_FUNCTIONALITY_STORAGE]: {
        //             label: 'Enables storage that supports the functionality of the website or app e.g. language settings.',
        //         },
        //         [SERVICE_PERSONALIZATION_STORAGE]: {
        //             label: 'Enables storage related to personalization e.g. video recommendations.',
        //         },
        //     }
        // },
        // [CAT_SECURITY]: {
        //     services: {
        //         [SERVICE_SECURITY_STORAGE]: {
        //             label: 'Enables storage related to security such as authentication functionality, fraud prevention, and other user protection.',
        //         },
        //     }
        // }
    },

    language: {
        default: 'en',
        translations: {
            en: {
                // See: https://support.google.com/tagmanager/answer/10718549?hl=en
                consentModal: {
                    title: 'We use cookies',
                    description: 'NOUS art studio uses essential cookies to ensure its proper operation and Google Analytics cookies to understand how you interact with it.',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject non-essential cookies',
                    showPreferencesBtn: 'Manage individual preferences'
                },
                preferencesModal: {
                    title: 'Manage cookie preferences',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    savePreferencesBtn: 'Accept current selection',
                    closeIconLabel: 'Close modal',
                    sections: [
                        {
                            title: "Cookie usage",
                            description: "We use cookies to ensure the basic functionalities of the website and to enhance your online experience."
                        },
                        {
                            title: "Strictly necessary cookies",
                            description: "These cookies are essential for the proper functioning of the website (for example for user authentication)",
                            linkedCategory: CAT_NECESSARY,
                            cookieTable: {
                                headers: {
                                    name: "Cookie",
                                    description: "Description",
                                    expiration: "Expiration"
                                },
                                body: [
                                    {
                                        name: "_art_studio_session",
                                        description: "User session: stores authentication details, messages, etc.",
                                        expiration: "Session"
                                    },
                                    {
                                        name: "remember_user_token",
                                        description: "Extends the login period beyond the current session",
                                        expiration: "After 2 weeks"
                                    },
                                    {
                                        name: "cc_cookie",
                                        description: "Consent details",
                                        expiration: "After 6 months"
                                    }
                                ]
                            }
                        },
                        {
                            title: "Google Analytics",
                            description: 'Cookies used for analytics help collect data that allows services to understand how users interact with a particular service. These insights allow services both to improve content and to build better features that improve the user’s experience.',
                            linkedCategory: CAT_ANALYTICS,
                            cookieTable: {
                                headers: {
                                    name: "Cookie",
                                    description: "Description",
                                    expiration: "Expiration"
                                },
                                body: [
                                    {
                                        name: "_ga*",
                                        description: "Set by <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a>",
                                        expiration: "After 12 days"
                                    },
                                    {
                                        name: "_gid",
                                        description: "Set by <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a>",
                                        expiration: "Session"
                                    }
                                ]
                            }
                        },
                        {
                            title: 'More information',
                            description: 'For any query in relation to our policy on cookies and your choices, please contact via <a class="cc__link" href="mailto:hi@nousartstudio.com">hi@nousartstudio.com</a>.'
                        }
                    ]
                }
            }
        }
    }
});
